import { api } from "./api";

export function pushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

async function getReg() {
  return (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.ready);
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, enabled: false, permission: "default" };
  try {
    const reg = await getReg();
    const sub = reg && (await reg.pushManager.getSubscription());
    return { supported: true, enabled: !!sub, permission: Notification.permission };
  } catch {
    return { supported: true, enabled: false, permission: Notification.permission };
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("non-supporte");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("refuse");
  const reg = await getReg();
  const { data } = await api.get("/push/vapid-public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.publicKey),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function disablePush() {
  try {
    const reg = await getReg();
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
      await sub.unsubscribe().catch(() => {});
    }
  } catch { /* noop */ }
  return true;
}

export async function getPushPrefs() {
  const { data } = await api.get("/push/preferences");
  return data.preferences;
}

export async function savePushPrefs(preferences) {
  const { data } = await api.put("/push/preferences", { preferences });
  return data.preferences;
}
